/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

export default function PencilIcon({
  width = 13,
  height = 13,
  color = '#3C5873',
}) {
  return (
    <svg width={width} height={height} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5778 0.512564C10.8944 -0.170853 9.78636 -0.170855 9.10294 0.512563L0.84434 8.77116C0.600039 9.01546 0.433517 9.32661 0.36576 9.66539L0.0233045 11.3777C-0.139964 12.194 0.579777 12.9138 1.39612 12.7505L3.1084 12.408C3.44718 12.3403 3.75833 12.1738 4.00263 11.9295L12.2612 3.67085C12.9446 2.98744 12.9446 1.8794 12.2612 1.19598L11.5778 0.512564ZM9.92789 1.33752C10.1557 1.10972 10.525 1.10971 10.7529 1.33752L11.4363 2.02094C11.6641 2.24874 11.6641 2.61809 11.4363 2.8459L9.87784 4.40432L8.36947 2.89595L9.92789 1.33752ZM7.54451 3.72091L1.6693 9.59612C1.58786 9.67755 1.53236 9.78127 1.50977 9.8942L1.16732 11.6065L2.87959 11.264C2.99252 11.2414 3.09624 11.1859 3.17767 11.1045L9.05289 5.22928L7.54451 3.72091Z"
        fill={color}
      />
    </svg>
  );
}

PencilIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};
